import { LabelType } from '@/model';
import labels from '@/store/labels';
import LabelTypesView from '@/views/LabelTypesView.vue';
import Vue, { VNode } from 'vue';

export default Vue.extend({
  name: 'LabelTypesController',
  components: {
    LabelTypesView,
  },

  data() {
    return {
      loading: false,
    };
  },

  computed: {
    allLabelTypes(): readonly LabelType[] {
      return labels.state.labelTypes;
    },
  },

  async mounted() {
    await this.load();
  },

  methods: {
    async load() {
      this.loading = true;
      await labels.dispatch.all();
      this.loading = false;
    },
  },

  render(create): VNode {
    return create(
      LabelTypesView, {
        props: {
          loading: this.loading,
          labelTypes: this.allLabelTypes,
        },
        on: {
          saved: this.load,
        },
      },
    );
  },
});
